import { render, staticRenderFns } from "./KoioteScreen.vue?vue&type=template&id=9027b70e&lang=es&"
import script from "./KoioteScreen.vue?vue&type=script&lang=js&"
export * from "./KoioteScreen.vue?vue&type=script&lang=js&"
import style0 from "./KoioteScreen.vue?vue&type=style&index=0&id=9027b70e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports